












import AppVue from "@/AppVue.vue";
import { Component, Prop, Watch } from "vue-property-decorator";
@Component({})
export default class MultiLineString extends AppVue {
  @Prop() source: string[];
  @Prop({ default: "p" }) tag: string;
}
